import { useEffect, useRef, useState, memo } from "react";

import { createAvatar } from "@dicebear/avatars";
import * as style from "@dicebear/avatars-initials-sprites";

import { FaFileInvoice, FaRegUser } from "react-icons/fa";
import { AiOutlineLogout } from "react-icons/ai";
import useOnClickOutside from "hooks/useOnClickOutside";
import { Link } from "react-router-dom";
import { useAuth } from "context/AuthContext";

export const AccountButton = () => {
  const { user } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  const { logout } = useAuth();
  const wrapperRef = useRef();
  useOnClickOutside(wrapperRef, () => setIsOpen(false));

  let svg = {};
  if (user && !user?.image) {
    svg = createAvatar(style, {
      seed: user.name ? user.name : "New",
      dataUri: true,
      // ... and other options
    });
  }

  useEffect(() => {}, [user]);
  return (
    <>
      {!user ? (
        <div className="flex items-center group ">
          <button
            onClick={() => {}}
            className="cursor-pointer space-x-2 flex items-center lg:mx-0 ml-auto mr-5  text-sm leading-5 py-2 px-4 sm:py-2 sm:px-5 sm:text-sm md:text-base   flex-shrink-0   text-white hover:text-white hover:bg-primary transition-all ease-out duration-300 text-center border border-primary rounded-lg"
          >
            <span>Account</span>
            <FaRegUser className=" h-6 w-6  text-primary group-hover:text-white" />
          </button>
        </div>
      ) : (
        <div className="flex items-center flex-shrink justify-center space-x-2  ">
          <span className="text-primary  lg:text-sm  ">
            Hello ,<br />
            {user.name}
          </span>

          <div
            ref={wrapperRef}
            onClick={() => {
              setIsOpen(!isOpen);
            }}
            className="relative  group w-[60px] h-[60px]  border-4 border-gray-700 hover:border-primary/80  rounded-full shadow-md cursor-pointer transition-all duration-300 ease-out"
          >
            {user?.user?.image ? (
              <img
                src={user.user.image}
                layout="fill"
                alt="user"
                className="rounded-full"
              />
            ) : (
              <img
                src={svg}
                layout="fill"
                alt="user"
                className="rounded-full"
              />
            )}

            <div
              className={`absolute overflow-hidden flex flex-col rounded-lg shadow-md text-sm    ${
                isOpen ? " opacity-100 scale-y-100 " : "scale-y-0 opacity-0 "
              }   -bottom-2 -right-1/2  w-[150px]  bg-header translate-y-full  origin-top transition-all duration-100 ease-out `}
            >
              <div className="flex flex-col w-full">
                <Link
                  to={"/mycases"}
                  className=" cursor-pointer over lg:mx-0 ml-auto w-full hover:bg-primary/10 hover:text-primary p-2  border-b border-main/40 text-xs   sm:text-sm   flex-shrink-0     transition-all ease-out duration-300 text-center "
                >
                  <div className="flex items-center justify-between px-2 space-x-2">
                    <span>My Cases</span>
                    <FaFileInvoice className="w-5 h-5" />
                  </div>
                </Link>
                <button
                  onClick={() => {
                    logout();
                  }}
                  className=" cursor-pointer over lg:mx-0 ml-auto w-full hover:bg-primary/10 hover:text-primary p-2  border-b border-main/40 text-xs   sm:text-sm    flex-shrink-0     transition-all ease-out duration-300 text-center "
                >
                  <div className="flex items-center justify-between px-2 space-x-2">
                    <span>Logout</span>
                    <AiOutlineLogout className="w-5 h-5" />
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default memo(AccountButton);
